import { APICall } from ".";

export const ax_login = async (data) => {
  try {
    const res = await APICall.post("/api/post/login", data);
    if (res.status === 200 || res.status === 201) {
      console.log("res - api login --> " + JSON.stringify(res));
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("e.response.data -> ", JSON.stringify(e.response));
    if (e.response.status === 404) return e.response.data;
    else return null;
  }
};
